module.exports = __webpack_public_path__ + "static/media/scholarship-4.5f8e1a00.jpg";